export enum Buckets {
    AccountSummary = 1,
    OrderTracking = 2,
    Ordering = 3,
    FinancialStatus = 4,
    HearingAidHistory = 5,
    SoftwareDownloads = 6,
    MarketPro = 7,
    WarrantyCenter = 8,
    LossAndDamageClaim = 9,
    PrintShippingLabel = 10,
    WorkshopRequest = 11,
    ManageUsers = 12,
    PatientBase = 14,
    BusinessTools = 15,
    OfficeInformation = 16,
    Consignment = 17,
    OrderApproval = 20,
    Preferences = 22,
    ManageCompanies = 77,
    ManageFacilities = 78,
    Joe = 79,
}
